import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectCurrentCluster } from "../../../store/slices/currentClusterSlice";
import { ROUTES } from "../../utils/constants";
import { useTheme } from "../../../common/hooks/useTheme";
import { useCookieBanner } from "./useCookieBanner";
import styles from "./CookieBanner.module.scss";
import { getLegalEntityPrefix } from "../../utils/functions/enumToText";

export const CookieBanner: React.FC = () => {
  const { isVisible, acceptCookies } = useCookieBanner();
  const currentCluster = useSelector(selectCurrentCluster);
  const { theme } = useTheme();

  const legalName = currentCluster?.legalName || currentCluster?.name || "Компания";
  const legalType = currentCluster?.legalEntityType;
  const prefix = getLegalEntityPrefix(legalType);
  const fullLegalName = prefix ? `${prefix} ${legalName}` : legalName;

  if (!isVisible) return null;

  return (
    <div className={styles.overlay}>
      <div 
        className={styles.banner} 
        style={{ 
          backgroundColor: theme.card, 
          borderColor: theme.border 
        }}
      >
        <div className={styles.content}>
          <p className={styles.text} style={{ color: theme.text }}>
            <strong>{fullLegalName}</strong> использует cookie
          </p>
          <p className={styles.description} style={{ color: theme.textSecondary }}>
            {fullLegalName} обрабатывает файлы cookie. Они помогают нам делать этот сайт удобнее 
            для пользователей. Нажав кнопку «Соглашаюсь», вы даёте своё согласие на обработку 
            файлов cookie вашего браузера. Однако вы можете запретить обработку некоторых типов 
            файлов cookie в настройках вашего браузера.
          </p>
          <p className={styles.description} style={{ color: theme.textSecondary }}>
            Обработка данных пользователей осуществляется в соответствии с{" "}
            <Link 
              to={ROUTES.PRIVACY_POLICY} 
              className={styles.link} 
              style={{ color: theme.primary }}
            >
              Политикой обработки персональных данных
            </Link>
            .
          </p>
          <button 
            className={styles.acceptButton} 
            onClick={acceptCookies}
            style={{ 
              backgroundColor: theme.primary, 
              color: theme.onPrimary 
            }}
          >
            СОГЛАСЕН
          </button>
        </div>
      </div>
    </div>
  );
};